// @ts-expect-error Signature pad does not have typescript support unfortunately. See usage here: https://www.npmjs.com/package/vue-signature-pad
import VueSignaturePad from 'vue-signature-pad'

export default defineNuxtPlugin((nuxtApp) => {
  // eslint-disable-next-line ts/no-unsafe-argument
  nuxtApp.vueApp.use(VueSignaturePad)
})
